import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routers from "./Route";
import { CompetitionProvider } from "./context/CompetitionContext";
import { LanguageProvider } from "./context/LanguageContext";

const App = () => {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <CompetitionProvider>
          <div className="App">
            <Routers />
          </div>
        </CompetitionProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
};

export default App;
